import { Message } from 'element-ui'

function handleError (err) {
  var message
  if (err.data.status_code === 401) {
    message = err.data.message || 'token过期,请退出重新登录'
    window.location.href = process.env.VUE_APP_LOGIN_URL
  } else if (/^4[0-9]{2}/.test(err.data.status_code)) {
    message = err.data.message || '网络错误，请稍后重试'
  } else {
    message = '服务器开小差儿，请稍后重试！'
  }
  Message.error(message)
}

function handleNetWork () {
  Message.error('网络错误，请检查网络！')
}

export default {
  handleError,
  handleNetWork
}
